<!-- Tab Content -->
<mic-spinner-overlay ariaLabel="loading" color="primary" [loading]="isLoading">

  <h1>{{ 'tire.title' | translate }}</h1>
  <p>{{ 'tire.description' | translate }}</p>

  <mat-card id="card-content" class="card-content">
    <tkc-modification-buttons
      [isModificationsPending]="isModificationPending"
      [saveModifications]="saveModifications.bind(this)"
      [resetModifications]="resetModifications.bind(this)"
      [matTooltipContent]="saveButtonTooltipContent"
      [isErrorTooltipSaveBtn]="isErrorTooltipSaveBtn"
    >
    </tkc-modification-buttons>

    <div class="filter-wrapper card-side-padding">
      <app-autocomplete
        [placeholder]="'common.filter.search' | translate"
        [label]="'tire.truckSpecification' | translate"
        [filterCtrl]="truckSpecfilterCtrl"
        [filteredList$]="truckSpecfilteredList$"
        [displayKey]="'specification'"
        [isLoading]="isFilterTruckLoading"
        (reset)="resetTruckSpecFilter()"
        (elementSelected)="onTruckSelected($event)"
      />
      <app-autocomplete
        [placeholder]="'common.filter.search' | translate"
        [label]="'tire.tireSpecification' | translate"
        [filterCtrl]="tireSpecfilterCtrl"
        [filteredList$]="tireSpecfilteredList$"
        [isLoading]="isFilterTireLoading"
        [displayKey]="'specificationFull'"
        (reset)="resetTireSpecFilter()"
        (elementSelected)="onTireSelected($event)"
      />
    </div>

    <app-truck-tires-table
      [truckTiresList]="truckTiresList"
      [tireSpecId]="selectedTireSpecId$.value"
      [truckSpecId]="selectedTruckSpecId$.value"
      [(isLoading)]="isLoading"
      [(isModificationPending)]="isModificationPending"
      [(isErrorTooltipSaveBtn)]="isErrorTooltipSaveBtn"
    />
    @if(!isLoading && truckTiresList && truckTiresList.length > 0) {
      <div class="edited-legend card-side-padding card-bottom-padding">
        <mat-icon class="edited-icon">circle</mat-icon>
        <span>{{ 'common.legend.redPoint' | translate }}</span>
      </div>
    }
  </mat-card>
</mic-spinner-overlay>
